import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=d10b35a0&scoped=true&"
import script from "./Emojis.vue?vue&type=script&lang=js&"
export * from "./Emojis.vue?vue&type=script&lang=js&"
import style0 from "./Emojis.vue?vue&type=style&index=0&id=d10b35a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10b35a0",
  null
  
)

export default component.exports